import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Form, Input} from 'semantic-ui-react';
import withChangeHandler from './withChangeHandler';

const TextboxWithChangeHandler = withChangeHandler(Input);

const MANAGED_PROPS = [
  'id',
  'questionLabel',
  'questionText',
  'modelKey',
  'value',
  'title',
  'style',
];

export default class extends React.Component {
  static propTypes = {
    /** A unique id */
    id: PropTypes.string,

    /** The label for the question */
    questionLabel: PropTypes.string,

    /** The text for the question */
    questionText: PropTypes.string.isRequired,

    /** The unique key of the property within the form backing model */
    modelKey: PropTypes.string.isRequired,

    /** The current value of the field */
    value: PropTypes.any,
  };

  constructor(props) {
    super(props);

    this.id = props.id;
    this.questionLabel = props.questionLabel;
    this.questionText = props.questionText;
    this.modelKey = props.modelKey;
    this.title = props.title;
  }

  render = () => {
    const filteredProps = _.omit(this.props, MANAGED_PROPS);

    return (
      <React.Fragment>
        {this.questionText && <div className="questionText">{this.questionText}</div>}
        <Form.Field>
          <label for={this.id}>{this.questionLabel}</label>
          <TextboxWithChangeHandler
            id={this.id}
            style={this.props.style}
            title={this.props.title}
            modelKey={this.modelKey}
            updateModel={this.props.updateModel}
            onBlur={this.props.blurModel}
            value={this.props.value}
            {...filteredProps}
          />
        </Form.Field>
      </React.Fragment>
    );
  };
}
